"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchLabel = exports.StyledSwitcher = exports.StyledBackground = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBackground = styled_components_1.default.div `
  background: ${({ theme }) => theme.colors.neutral['20']};
`;
const getBackground = (checked, theme, disabled, hasBackground) => {
    if (!hasBackground) {
        return '';
    }
    if (disabled) {
        return theme.colors.neutral['30'];
    }
    return checked ? theme.colors.neutral['100'] : theme.colors.neutral['20'];
};
exports.StyledSwitcher = styled_components_1.default.div `
  cursor: pointer;
  text-indent: -9999px;
  width: 46px;
  height: 28px;
  background: ${({ checked, theme, disabled, hasBackground }) => getBackground(checked, theme, disabled, hasBackground)};
  display: block;
  border-radius: 100px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    right: ${({ checked }) => (checked ? '3px' : 'calc(55% - 6px)')};
    top: 2px;
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.colors.surface.primary};
    border-radius: 100px;
    transition: 0.3s;
  }
`;
exports.SwitchLabel = styled_components_1.default.label `
  ${theme_1.typography.regular18}
  line-height: 26px;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  ${({ labelDirection }) => theme_1.mixins.flex({
    alignItems: 'center',
    gap: 12,
    reverse: labelDirection !== 'normal',
    direction: 'row',
})}
`;
